import { http, HttpResponse, HttpHandler } from 'msw';

import { LegalDocument } from '../../../domain/config';

const createLegalDocumentsHandler = (documents?: LegalDocument[]) =>
  http.get<never, never, LegalDocument[]>('/qualification/legal-documents', () => {
    return HttpResponse.json(documents ?? []);
  });

const handlers: HttpHandler[] = [createLegalDocumentsHandler()];

export { handlers, createLegalDocumentsHandler };
